module.exports = __webpack_public_path__ + "819f3e986c5e8bb315aec2be3b1a1ff6.png";